import api from "../globals/axios";
import {
  SUBSCRIPTION_CREATE_ORDER,
  SUBSCRIPTION_CAPTURE_PAYMENT,
  SUBSCRIPTION_GET_PLANS,
} from "../globals/endpoints";

const GET_SUBSCRIPTION_FOR_FARM = "/payments/get-subscription-for-farm/";
const GET_PLANS_FOR_FARM = "/payments/get-available-farm-plans/";
const GET_ACTIVE_SUBSCRIPTIOSN = "/payments/get-active-subscriptions/";

export async function createOrder(farmId, plan) {
  const response = await api.post(SUBSCRIPTION_CREATE_ORDER, {
    farm_id: farmId,
    plan: plan,
  });
  return response.data;
}

export async function capturePayment(orderId, paymentId, signature) {
  const response = await api.post(SUBSCRIPTION_CAPTURE_PAYMENT, {
    order_id: orderId,
    payment_id: paymentId,
    signature,
  });
  return response.status === 200;
}

export async function getActiveSubscriptions() {
  const response = await api.get(`${GET_ACTIVE_SUBSCRIPTIOSN}`);
  return response.data;
}

export async function getAvailablePlans() {
  const response = await api.get(`${SUBSCRIPTION_GET_PLANS}`);
  return response.data;
}

export async function getAvailableFarmPlans(farmId) {
  const response = await api.get(`${GET_PLANS_FOR_FARM}?farm_id=${farmId}`);
  return response.data;
}

export async function getSubscriptionForFarm(farmId) {
  const response = await api.get(
    `${GET_SUBSCRIPTION_FOR_FARM}?farm_id=${farmId}`
  );
  return response.data;
}
